<template>
  <div>
    <!-- Filtros -->
    <v-row class="px-2 py-2 mt-6 mb-6" dense>
      <!-- Fecha Desde -->
      <v-col cols="12" md="6" sm="6" class="align-self-end">
        <datePicker
          v-model="filtros.fechaDesde"
          format="YYYY-MM-DD"
          label="Desde (Obligatorio)"
          clearable
          maxToday
          :disabled="cargando"
          :maxDate="filtros.fechaHasta"
        />
      </v-col>

      <!-- Fecha Hasta -->
      <v-col cols="12" md="6" sm="6" class="align-self-end">
        <datePicker
          v-model="filtros.fechaHasta"
          format="YYYY-MM-DD"
          label="Hasta (Obligatorio)"
          clearable
          maxToday
          :disabled="cargando"
          :minDate="filtros.fechaDesde"
        />
      </v-col>
      <v-col cols="12" md="6">
        <v-autocomplete
          v-model="filtros.rol"
					:items="roles"
					label="Rol"
					item-text="nombre"
					item-value="idRol"
          dense
          clearable
          multiple
          chips
        />
      </v-col>
      <v-col cols="12" md="6">
        <v-autocomplete
          v-model="filtros.usuario"
          :items="dataUsuarios"
          label="Usuario"
          item-text="nombre"
					item-value="idUsuario"
          dense
          clearable
          multiple
          chips
        />
      </v-col>
      <v-col cols="12" md="6">
        <v-autocomplete
          v-model="filtros.turno"
          :items="turnos"
          label="Turno"
          item-text="nombre"
					item-value="idTurno"
          dense
          clearable
          multiple
          chips
        />
      </v-col>
      <v-col cols="12" md="6">
        <v-autocomplete
          v-model="filtros.articulo"
          :items="articulos"
          label="Artículo"
          item-text="articulo"
					item-value="idArticulo"
          dense
          clearable
          multiple
          chips
        />
      </v-col>
      <v-col cols="12" class="text-right">
        <v-btn color="primary" @click="initialize();">
          Buscar
        </v-btn>
      </v-col>
    </v-row>

    <!-- Gráficos de barras -->
    <v-row justify="center">
      <v-col cols="12" md="8" sm="10">
        <v-col cols="12">
        <div class="text-h5 text-center font-weight-bold mb-2">
            Tiempo de Paros y Alertas
        </div>
        </v-col>
        <v-card v-if="loadingTiempos" elevation="0">
          <br><br>
          <div class="text-h6 text-center">Cargando Tiempos</div>
          <br>
          <div class="text-center">
            <v-progress-circular
              :size="50"
              color="primary"
              indeterminate
            ></v-progress-circular>
          </div>
          <br><br>
        </v-card>
        <apexchart
            v-if="!loadingTiempos && tiempos.length"
            type="bar"
            height="380"
            :options="TiemposchartOptions"
            :series="TiemposSeries"
            ref="chartTiempos"
        />
      </v-col>
    </v-row>

    <!-- Tabla de resultados -->
    <v-data-table
      :headers="headers"
      :items="items"
      :items-per-page="10"
      class="elevation-1"
      dense
    >
       <!-- formateo «Tiempo de Aviso» -->
      <template v-slot:item.tiempoAviso="{ item }">
        {{ item.tiempoAvisoStr || '00:00:00' }}
      </template>

      <template v-slot:item.tiempoRespuesta="{ item }">
        {{ item.tiempoRespuestaStr || '00:00:00' }}
      </template>
    </v-data-table>
  </div>
</template>

<script>
import axios from "axios";
import qs    from 'qs';

export default {
  data() {
    const hoy = new Date();
    const inicioMes = new Date(hoy.getFullYear(), hoy.getMonth(), 1);
    return {
        filtros: {
          rol: [],
          usuario: [],
          turno: [],
          articulo: [],
          fechaDesde: inicioMes.toISOString().substring(0, 10),
          fechaHasta: hoy.toISOString().substring(0, 10),
        },
        tiempos: [],
        loadingTiempos: false,
        roles: [],
        dataUsuarios: [],
        turnos: [],
        articulos: [],
        items: [],
        mttr:[],
        headers: [
          //{ text: 'Rol que Presentó',       value: 'nombreRolPresento' },
          //{ text: 'Usuario que Presentó',   value: 'nombreUsuarioPresento' },
          { text: 'Roles Alertados',        value: 'rolesAlertados' },
          { text: 'Tiempo de Aviso',        value: 'tiempoAviso' },
          { text: 'Tiempo de Respuesta',    value: 'tiempoRespuesta' },
          //{ text: 'Tiempo Total de Paro',   value: 'tiempoTotalParo' },
          { text: 'Turno',                  value: 'turno' },
          { text: 'Artículo',               value: 'nombreArticulo' }
        ],
        TiemposSeries: [
        { name: "Tiempo de Aviso", data: [] },
        { name: "Tiempo de Respuesta", data: [] }
        //{ name: "Tiempo de Paro", data: [] }
        ],
        TiemposchartOptions: {},
        defaultTiemposChartOptions: {
        chart: { height: 380, type: 'bar', toolbar: { show: false } },
        plotOptions: {
          bar: {
            columnWidth: '45%',
            dataLabels: { position: 'top' }
          }
        },
        dataLabels: {
          enabled: true,
          formatter(val) {
            const totalSeconds = Math.floor(val * 3600); // si val está en horas, conviértelo a segundos

            const days = Math.floor(totalSeconds / 86400); // 86400 = 24*60*60
            const hours = Math.floor((totalSeconds % 86400) / 3600);
            const minutes = Math.floor((totalSeconds % 3600) / 60);
            const seconds = totalSeconds % 60;

            const d = days.toString();
            const h = hours.toString().padStart(2, '0');
            const m = minutes.toString().padStart(2, '0');
            const s = seconds.toString().padStart(2, '0');

            return days > 0 ? `${d}d ${h}:${m}:${s}` : `${h}:${m}:${s}`;
          },
          offsetY: -20,
          style: {
            fontSize: '24px',
            fontWeight: 'bold',
            colors: ['#000']
          }
        },
        legend: {
          show: true,
          position: 'top',
          horizontalAlign: 'right',
          labels: { colors: '#000' }
        },
        xaxis: {
          categories: [],
          labels: { style: { fontSize: '12px' } }
        },
        yaxis: {
          labels: {
            formatter(val) {
              const totalSeconds = Math.floor(val * 3600); // si val está en horas, conviértelo a segundos

              const days = Math.floor(totalSeconds / 86400); // 86400 = 24*60*60
              const hours = Math.floor((totalSeconds % 86400) / 3600);
              const minutes = Math.floor((totalSeconds % 3600) / 60);
              const seconds = totalSeconds % 60;

              const d = days.toString();
              const h = hours.toString().padStart(2, '0');
              const m = minutes.toString().padStart(2, '0');
              const s = seconds.toString().padStart(2, '0');

              return days > 0 ? `${d}d ${h}:${m}:${s}` : `${h}:${m}:${s}`;
            }
          }
        }
      }
    };
  },
  mounted() {
    this.initialize();
  },
  methods: {
    initialize(){
      this.obtenerReporteTiemposAlertas();
      this.cargarTiemposPorRol();
      this.getRoles();
      this.getUsuarios();
      this.getTurnos();
      this.getArticulosOrdenes();
    },
    formatDuration(ts) {
      if (!ts) return '00:00:00';

      let days = 0;
      let timePart = ts;

      // Si tiene parte de día (ej. "2.01:23:45")
      if (typeof ts === 'string' && ts.includes('.')) {
        const parts = ts.split('.');
        days = parseInt(parts[0], 10);
        timePart = parts[1];
      }

      // Separar horas, minutos, segundos
      const [h = 0, m = 0, s = 0] = timePart.split(':').map(v => parseInt(v, 10));

      const HH = String(h).padStart(2, '0');
      const MM = String(m).padStart(2, '0');
      const SS = String(s).padStart(2, '0');

      return days > 0 ? `${days}d ${HH}:${MM}:${SS}` : `${HH}:${MM}:${SS}`;
    },
    getRoles(){
      this.loadingRoles = true;
      axios
        .get("/Permisos/Roles")
        .then((response) => {
          this.roles = response.data;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loadingRoles = false;
        });
    },
    getUsuarios() {
      axios
        .get("/Usuarios/Listar")
        .then(response => { this.dataUsuarios = response.data })
        .catch(error => { console.log(error.response) })
    },
    getTurnos(){
      axios
      .get('/ComandoYControl/Turnos')
      .then(response => {
        this.turnos = response.data;
      })
      .catch(error => {
        console.log(error);
      })
    },
    getArticulosOrdenes(){
      this.loading = true;
      axios
      .get("/TrabajoOrdenes/Articulos")
      .then(response => {
        this.articulos = response.data.map(a => {
          a.seleccion = [];
          return a;
        });
        this.loading = false;
      })
      .catch(error => {
        console.log(error);
        this.loading = false;
      })
    },
    async cargarTiemposPorRol() {
      this.loadingTiempos = true;
      try {
        const resp = await axios.get('/TiempoParosAlertas/ReporteTiemposPorRol', { params: this.filtros,
          paramsSerializer: params =>
          qs.stringify(params, { arrayFormat: 'repeat' })
        });
        this.tiempos = resp.data.map(x => ({
          ...x,
          tiempoAviso: (x.tiempoAviso || 0) / 3600,
          tiempoRespuesta: (x.tiempoRespuesta || 0) / 3600,
          tiempoParo: (x.tiempoParo || 0) / 3600
        }));

        // 1. Actualiza tu serie
        this.TiemposSeries = [
          //{ name: "Tiempo de Paro",      data: this.tiempos.map(x => x.tiempoParo) },
          { name: "Tiempo de Respuesta", data: this.tiempos.map(x => x.tiempoRespuesta) },
          { name: "Tiempo de Aviso",     data: this.tiempos.map(x => x.tiempoAviso) }
        ];

        // Calcula dinámicamente un 20% de “colchón” sobre el valor máximo:
        const maxParo = Math.max(...this.TiemposSeries[0].data);
        const yMax    = maxParo * 1.2;

        // Actualiza opciones de ejes:
        const opts = {
          ...this.defaultTiemposChartOptions,
          xaxis: {
            ...this.defaultTiemposChartOptions.xaxis,
            categories: this.tiempos.map(x => `${x.rol}`)
          },
          yaxis: {
            ...this.defaultTiemposChartOptions.yaxis,
            min: 0,
            max: yMax,
            tickAmount: 6,          // número de divisiones
            forceNiceScale: true    // redondea bonitas las marcas
          }
        };

        this.TiemposchartOptions = opts;

        // 3. (Opcional) Si quieres forzar al componente a refrescar:
        if (this.$refs.chartTiempos) {
          this.$refs.chartTiempos.updateOptions({
            series: this.TiemposSeries,
            xaxis:  opts.xaxis
          }, false, true);
        }

      } catch (e) {
        console.error(e);
      } finally {
        this.loadingTiempos = false;
      }
    },
    async obtenerReporteTiemposAlertas() {
      try {
        const response = await axios.get('/TiempoParosAlertas/AlertarTurno', { params: this.filtros,
          paramsSerializer: params =>
          qs.stringify(params, { arrayFormat: 'repeat' })
        });
        this.items = response.data;
      } catch (error) {
        console.error("Error al obtener datos:", error);
      }
    },
    formatRoles(jsonRoles) {
      try {
        const obj = JSON.parse(jsonRoles);
        return Object.entries(obj)
          .map(([categoria, ids]) => `<strong>${categoria}:</strong> ${ids.join(', ')}`)
          .join('<br>');
      } catch {
        return jsonRoles;
      }
    },
    async historial_update_page_action() {
      this.loadingTiempos = true;
      this.getTiempos()
      .then(response => {
          this.tiempos = response.data;
          this.loadingTiempos = false;
          var TiemposChartOptions = Object.assign({}, this.defaultTiemposChartOptions);
          TiemposChartOptions.xaxis.categories = this.tiempos.map(x => x.IdParo);

          var TiemposSeries = [{
              data: this.tiempos.map(x => x.tiempos),
              name: "Tiempos"
          }];

          this.TiemposchartOptions = TiemposChartOptions;
          this.TiemposSeries = TiemposSeries;

          setTimeout(() => {
            //this.$refs.chartMTTR.refresh();
          }, 350);
      })
      .catch(error => {
        console.log(error);
      });
    },
  }
};
</script>